import { gql } from '@apollo/client'

export const FIND_MY_USER = gql`
  query findMyUser {
    findMyUser {
      id
      firstName
      lastName
      email
      role
      countdownToExam {
        platform
        countdown
      }
      membership {
        type
        platform {
          id
          slug
          title
        }
        pauseTokensCount
        pausedAt
        expiresTo
      }
      selectedPlatform
      getAvatar {
        photo
      }
    }
  }
`

export const GET_PLATFORMS = gql`
  query findAllPlatforms($query: PlatformQueryInput!) {
    findAllPlatforms(query: $query) {
      count
      items {
        id
        title
        category
        shortDescription
        description
        isActive
        slug
      }
    }
  }
`

export const GET_SUBJECTS_BY_PLATFORMS = gql`
  query findSimilarSubjectsByPlatforms($platformIds: [String!]!) {
    findSimilarSubjectsByPlatforms(platformIds: $platformIds) {
      id
      tabName
      slug
      platform {
        id
        title
        category
        shortDescription
        description
        isActive
        slug
      }
    }
  }
`

export const GET_SIGNED_URL = gql`
  query getSignedUrls($query: S3FileInput!) {
    getSignedUrls(query: $query)
  }
`
